import useDarkMode from '@/utils/hooks/utils/useDarkMode';

type RedditIconProps = React.ComponentPropsWithRef<'svg'>;

export function RedditIcon({ ...restProps }: RedditIconProps) {
    const { isDarkMode } = useDarkMode();

    if (isDarkMode()) {
        return (
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                {...restProps}>
                <g clipPath="url(#clip0_115_4025)">
                    <path
                        d="M12 0C5.373 0 0 5.373 0 12C0 15.314 1.343 18.314 3.515 20.485L1.229 22.771C0.775 23.225 1.097 24 1.738 24H12C18.627 24 24 18.627 24 12C24 5.373 18.627 0 12 0ZM16.388 3.199C17.492 3.199 18.387 4.094 18.387 5.198C18.387 6.303 17.492 7.198 16.388 7.198C15.442 7.198 14.649 6.541 14.441 5.659V5.661C13.294 5.823 12.409 6.811 12.409 8.002V8.009C14.185 8.076 15.809 8.576 17.095 9.372C17.568 9.009 18.159 8.792 18.802 8.792C20.349 8.792 21.604 10.046 21.604 11.594C21.604 12.711 20.949 13.675 20.003 14.125C19.915 17.381 16.366 20.001 12.006 20.001C7.645 20.001 4.101 17.384 4.008 14.131C3.054 13.684 2.394 12.716 2.394 11.593C2.394 10.045 3.649 8.791 5.197 8.791C5.842 8.791 6.436 9.009 6.909 9.376C8.184 8.586 9.79 8.085 11.549 8.011V8.001C11.549 6.338 12.812 4.967 14.429 4.794C14.617 3.883 15.422 3.199 16.388 3.199ZM8.303 11.575C7.519 11.575 6.844 12.355 6.797 13.372C6.75 14.388 7.437 14.801 8.223 14.801C9.009 14.801 9.594 14.432 9.641 13.416C9.688 12.399 9.088 11.575 8.303 11.575ZM15.709 11.575C14.923 11.575 14.324 12.399 14.371 13.416C14.418 14.433 15.005 14.801 15.789 14.801C16.574 14.801 17.262 14.388 17.215 13.372C17.169 12.355 16.494 11.575 15.709 11.575ZM12.006 15.588C11.032 15.588 10.099 15.636 9.236 15.723C9.089 15.738 8.995 15.891 9.053 16.028C9.536 17.182 10.675 17.992 12.006 17.992C13.336 17.992 14.476 17.182 14.959 16.028C15.016 15.891 14.922 15.738 14.775 15.723C13.912 15.636 12.98 15.588 12.006 15.588Z"
                        fill="white"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_115_4025">
                        <rect width="24" height="24" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        );
    }

    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...restProps}>
            <g clipPath="url(#clip0_115_4067)">
                <path
                    d="M12 0C5.373 0 0 5.373 0 12C0 15.314 1.343 18.314 3.515 20.485L1.229 22.771C0.775 23.225 1.097 24 1.738 24H12C18.627 24 24 18.627 24 12C24 5.373 18.627 0 12 0ZM16.388 3.199C17.492 3.199 18.387 4.094 18.387 5.198C18.387 6.303 17.492 7.198 16.388 7.198C15.442 7.198 14.649 6.541 14.441 5.659V5.661C13.294 5.823 12.409 6.811 12.409 8.002V8.009C14.185 8.076 15.809 8.576 17.095 9.372C17.568 9.009 18.159 8.792 18.802 8.792C20.349 8.792 21.604 10.046 21.604 11.594C21.604 12.711 20.949 13.675 20.003 14.125C19.915 17.381 16.366 20.001 12.006 20.001C7.645 20.001 4.101 17.384 4.008 14.131C3.054 13.684 2.394 12.716 2.394 11.593C2.394 10.045 3.649 8.791 5.197 8.791C5.842 8.791 6.436 9.009 6.909 9.376C8.184 8.586 9.79 8.085 11.549 8.011V8.001C11.549 6.338 12.812 4.967 14.429 4.794C14.617 3.883 15.422 3.199 16.388 3.199ZM8.303 11.575C7.519 11.575 6.844 12.355 6.797 13.372C6.75 14.388 7.437 14.801 8.223 14.801C9.009 14.801 9.594 14.432 9.641 13.416C9.688 12.399 9.088 11.575 8.303 11.575ZM15.709 11.575C14.923 11.575 14.324 12.399 14.371 13.416C14.418 14.433 15.005 14.801 15.789 14.801C16.574 14.801 17.262 14.388 17.215 13.372C17.169 12.355 16.494 11.575 15.709 11.575ZM12.006 15.588C11.032 15.588 10.099 15.636 9.236 15.723C9.089 15.738 8.995 15.891 9.053 16.028C9.536 17.182 10.675 17.992 12.006 17.992C13.336 17.992 14.476 17.182 14.959 16.028C15.016 15.891 14.922 15.738 14.775 15.723C13.912 15.636 12.98 15.588 12.006 15.588Z"
                    fill="#FF4500"
                />
            </g>
            <defs>
                <clipPath id="clip0_115_4067">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
